/* Sanatlyn cart runtime.
   Two jobs:
   1. The cross-sell "Add" button — POST to /cart/add, then announce it the way the theme
      expects (cart:update dispatched from document.body, never from inside a
      cart-items-component, whose own handler ignores events it is the target of).
   2. A self-heal net for the drawer. If, shortly after any cart change, the drawer markup
      still disagrees with /cart.js (classic symptom: you add an item and the drawer is
      blank or still shows the empty state), re-render the drawer section straight from
      Shopify and swap it in. Also opens the drawer if an add did not open it. */
(function () {
  if (window.__snCartBound) return;
  window.__snCartBound = true;

  var HEAL_DELAY = 450;
  var healing = false;

  function drawerComponent() {
    return document.querySelector('cart-drawer-component');
  }

  function drawerItemsComponent() {
    var drawer = drawerComponent();
    return drawer ? drawer.querySelector('cart-items-component[data-section-id]') : null;
  }

  function sectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) {
        return el.getAttribute('data-section-id');
      })
      .filter(function (id, index, all) {
        return id && all.indexOf(id) === index;
      });
  }

  /* ---------------------------------------------------------------- cross-sell add */

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-sn-add]') : null;
    if (!button || button.disabled) return;
    event.preventDefault();

    var wrapper = button.closest('[data-cart-add-url]');
    var addUrl = (wrapper && wrapper.getAttribute('data-cart-add-url')) || '/cart/add';
    var variantId = button.getAttribute('data-sn-add');

    button.disabled = true;
    button.classList.add('is-loading');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds().join(',')
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        document.body.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: 'sanatlyn-cart-upsell',
              data: {
                source: 'product-form-component',
                itemCount: 1,
                sections: data && data.sections
              }
            }
          })
        );
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  });

  /* --------------------------------------------------------------- drawer self-heal */

  function drawerLooksEmpty(root) {
    if (!root) return true;
    return !root.querySelector('.cart-form');
  }

  function syncEmptyClass(itemsComponent) {
    var drawer = drawerComponent();
    var dialog = drawer && drawer.querySelector('dialog');
    if (!dialog) return;
    dialog.classList.toggle('cart-drawer--empty', drawerLooksEmpty(itemsComponent));
  }

  function healDrawer() {
    var itemsComponent = drawerItemsComponent();
    if (!itemsComponent || healing) return Promise.resolve();
    var sectionId = itemsComponent.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();

    healing = true;
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);

    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-items-component[data-section-id]');
        if (!fresh) return;
        itemsComponent.innerHTML = fresh.innerHTML;
        syncEmptyClass(itemsComponent);
      })
      .catch(function () {})
      .then(function () {
        healing = false;
      });
  }

  function verifyAfterCartChange(shouldOpen) {
    window.setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var itemsComponent = drawerItemsComponent();
          if (!itemsComponent) return null;

          var domIsEmpty = drawerLooksEmpty(itemsComponent);
          var mismatch = (cart.item_count > 0 && domIsEmpty) || (cart.item_count === 0 && !domIsEmpty);

          if (mismatch) return healDrawer();
          syncEmptyClass(itemsComponent);
          return null;
        })
        .then(function () {
          if (!shouldOpen) return;
          var drawer = drawerComponent();
          var dialog = drawer && drawer.querySelector('dialog');
          if (drawer && dialog && !dialog.open && typeof drawer.open === 'function') {
            drawer.open();
          }
        })
        .catch(function () {});
    }, HEAL_DELAY);
  }

  document.addEventListener(
    'cart:update',
    function (event) {
      var detail = event && event.detail;
      var source = detail && detail.data && detail.data.source;
      var isAdd = source === 'product-form-component';
      verifyAfterCartChange(isAdd);
    },
    true
  );
})();